<template>
  <li class="dropdown_menu" :class="mainExamListCssObj">
    <a v-b-toggle.discussionCollapse>
      <b-icon-chat-right-text-fill />

      <span class="link-title menu_hide ml-1">กระดานถาม-ตอบ</span>
      <span class="fa arrow menu_hide"></span>
    </a>
    <b-collapse id="discussionCollapse" :visible="false" accordion="accordion">
      <main-collapse-menu
        :collapse-list="collapseList"
        :is-active="!isActive"
      />
    </b-collapse>
  </li>
</template>

<script>
import MainCollapseMenu from "@/components/layouts/sidebars/collapse-menu/MainCollapseMenu.vue";
import _ from "lodash";
import authMixin from "@/mixins/auth-mixin.js";
import { checkSubMenuAccess } from "../../../../services/accessControl";

export default {
  components: {
    MainCollapseMenu,
  },
  mixins: [authMixin],
  data() {
    return {
      isActive: false,
      collapseList: [],
    };
  },
  computed: {
    mainExamListCssObj() {
      return {
        active: this.isActive,
      };
    },
  },
  watch: {},
  mounted() {
    if (
      checkSubMenuAccess({ menu: "discussion-mgmt" }, this.getCurrentUser())
    ) {
      this.collapseList.push({
        title: "สรุปภาพรวมคำถาม",
        to: {
          name: "analytics.discuss",
        },
      });
    }
  },
  methods: {
    checkActiveRoute() {
      const useModuleMetaMatcher = !!this.$route.meta.module;
      this.isActive = _.includes(
        _.map(this.collapseList, (ech) => {
          if (!!ech.meta && !!ech.meta.module) {
            return ech.meta.module;
          }
          return ech.to.name;
        }),
        useModuleMetaMatcher ? this.$route.meta.module : this.$route.name
      );
    },
  },
};
</script>
